import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProfileImage from './profile-image-model'
import {
  CreateProfileImageAsync,
  DeleteProfileImageAsync,
  LoadProfileImagesAsync,
} from './profileImage-thunk'
const initialState: profileImageSliceState = {
  profileImage: [],
  selected_profileImage: '',
  is_loading_profileImage: false,
  is_creating_profileImage: false,
  is_deleting_profileImage: false,
}
export interface profileImageSliceState {
  profileImage: ProfileImage[]
  selected_profileImage?: string
  is_loading_profileImage: boolean
  is_creating_profileImage: boolean
  is_deleting_profileImage: boolean
}
export const profileImageSlice = createSlice({
  name: 'profileImage',
  initialState,
  reducers: {
    setSelectedprofileImage: (state, action) => {
      state.selected_profileImage = action.payload
    },
    clearStateprofileImage: (state) => {
      state.profileImage = []
      state.is_loading_profileImage = false
      state.is_creating_profileImage = false
      state.is_deleting_profileImage = false
    },
    mergeprofileImage: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileImage = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileImage = merge(state.profileImage, payload) as any
        }
      }
    },

    add_profileImage: (state, action) => {
      if (action.payload) {
        state.profileImage = [...state.profileImage, action.payload]
      }
    },
    set_profileImage: (state, action) => {
      let { key, value, id } = action.payload
      state.profileImage = state.profileImage.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileImagesAsync.pending, (state) => {
      state.is_loading_profileImage = true
    })
    builder.addCase(LoadProfileImagesAsync.fulfilled, (state, action) => {
      state.is_loading_profileImage = false
      if (action.payload) {
        state.profileImage = action.payload
      }
    })
    builder.addCase(LoadProfileImagesAsync.rejected, (state) => {
      state.is_loading_profileImage = false
    })
    builder.addCase(CreateProfileImageAsync.pending, (state) => {
      state.is_creating_profileImage = true
    })
    builder.addCase(CreateProfileImageAsync.fulfilled, (state) => {
      state.is_creating_profileImage = false
    })
    builder.addCase(CreateProfileImageAsync.rejected, (state) => {
      state.is_creating_profileImage = false
    })
    builder.addCase(DeleteProfileImageAsync.pending, (state) => {
      state.is_deleting_profileImage = true
    })
    builder.addCase(DeleteProfileImageAsync.fulfilled, (state, action) => {
      state.is_deleting_profileImage = false
      if (state.profileImage) {
        state.profileImage = state.profileImage.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProfileImageAsync.rejected, (state) => {
      state.is_deleting_profileImage = false
    })
  },
})

export const {
  clearStateprofileImage,
  setSelectedprofileImage,
  set_profileImage,
  mergeprofileImage,
  add_profileImage,
} = profileImageSlice.actions

export const get_profileImage =
  (id?: string) =>
  (state: {
    profileImage: {
      profileImage: ProfileImage[]
    }
  }): ProfileImage | null => {
    let temp = state?.profileImage?.profileImage?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profileImage?.profileImage[0] || null
  }
export const get_selected_profileImage = (state: {
  profileImage: profileImageSliceState
}): ProfileImage | null => {
  let id = state?.profileImage?.selected_profileImage
  let temp = state?.profileImage?.profileImage?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileImage = (state: {
  profileImage: {
    profileImage: ProfileImage[]
  }
}): ProfileImage[] => {
  let temp = state?.profileImage?.profileImage
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileImage_busy = (state: {
  profileImage: profileImageSliceState
}) => {
  return (
    state?.profileImage.is_deleting_profileImage ||
    state?.profileImage.is_loading_profileImage ||
    state?.profileImage.is_creating_profileImage
  )
}
export const is_deleting_profileImage_busy = (state: {
  profileImage: profileImageSliceState
}) => {
  return state?.profileImage.is_deleting_profileImage
}
export const is_loading_profileImage_busy = (state: {
  profileImage: profileImageSliceState
}) => {
  return state?.profileImage.is_loading_profileImage
}
export const is_creating_profileImage_busy = (state: {
  profileImage: profileImageSliceState
}) => {
  return state?.profileImage.is_creating_profileImage
}

export default profileImageSlice.reducer
